export const logLevels = [
  "silly",
  "verbose",
  "debug",
  "info",
  "warn",
  "error",
] as const;

export type LogLevel = (typeof logLevels)[number];

type LogFn = (tag: string, message: any, ...parts: any[]) => void;

type Log = Record<LogLevel, LogFn>;

function consoleLog(): Log {
  const log =
    (level: "trace" | "debug" | "info" | "warn" | "error") =>
    (tag: string, message: any, ...parts: ReadonlyArray<any>) =>
      console[level](`[${tag}] ${[message, ...parts].join(" ")}`);

  return {
    silly: log("trace"),
    verbose: log("debug"),
    debug: log("debug"),
    info: log("info"),
    warn: log("warn"),
    error: log("error"),
  };
}

const log = consoleLog();

export type LogMessage = {
  timestamp: Date;
  level: LogLevel;
  tag: string;
  message: unknown;
  parts: Array<unknown>;
};

export const logMessages: Array<LogMessage> = [];

export type Logger = Record<LogLevel, (...args: any) => void>;

/**
 * Create a logger that prefixes messages with a colorful tag.
 */
export function logger(tag: string): Logger {
  const ret = {} as Logger;

  for (const level of logLevels) {
    ret[level] = (message, ...parts: any) => {
      log[level](tag, message, ...parts);
      logMessages.push({ timestamp: new Date(), level, tag, message, parts });
    };
  }

  return ret;
}
